export default "__VITE_ASSET__BGlu2My2__"